type RetrieveResourceProjectsQuery = {
  start: number;
  limit: number;
};

const retrieveResourceProjectsQuery: RetrieveResourceProjectsQuery = {
  start: 0,
  limit: 0,
};

export type { RetrieveResourceProjectsQuery };

export { retrieveResourceProjectsQuery };
